import requestAction from '../../utils/requestAction'

export const fetchComplaint = (complaintId: string) =>
  requestAction('COMPLAINT_DETAIL')(`complaints/${complaintId}`, 'GET')
